// extracted by mini-css-extract-plugin
module.exports = {"item":"k-","dark":"k_","light":"la","toggle":"lb"};